import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../store/actions/payrollActions';
import { Actions as EMPLOYEE_ACTIONS } from '../../store/actions/employeeActions';
import ReactDOM from "react-dom";
// import axios from 'axios';
import _ from 'lodash';
import "react-datepicker/dist/react-datepicker.css";
import 'react-notifications/lib/notifications.css';
import { format, setHours, setMinutes, setSeconds, subMonths } from 'date-fns'
import Select from 'react-select';
import { XMarkIcon } from '@heroicons/react/20/solid'
import Spinner from "../common/Spinner";

const PayTerminatedEmployeeModal = ({
  employeeOptions,
  terminatedEmployees,
  getTerminatedEmployees,
  closeModal,
  addPayslip,
  processing,
  show,

}) => {

  useEffect(() => {
    if (show) getTerminatedEmployees()
  }, [show])

  const [employee, setEmployee] = useState(false);

  if (!show) return null

  return (
    <div className="modal" tabindex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="block block-themed block-transparent remove-margin-b" style={{ padding: 0 }}>
            <div className="block-header bg-primary-dark" style={{ padding: "15px 20px" }}>
              <ul className="block-options">
                <li>
                  <button type="button" onClick={() => { closeModal() }}>
                    <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                  </button>
                </li>
              </ul>
              <h3 className="block-title">Pay Terminated Employee</h3>
            </div>
            <div className="block-content" style={{ padding: "20px 20px 1px" }}>

              <p>Do you want to create an extra payslip to settle any pending amounts with a recently terminated employee?.</p>

              <div className="form-group">
                {
                  employeeOptions &&
                  <div className="col-sm-6" style={{ paddingLeft: 0 }}>
                    <label htmlFor="material-text">Employee</label>
                    <Select
                      value={employee}
                      options={employeeOptions}
                      onChange={setEmployee}
                    />
                    <div className="clearfix"></div>
                  </div>
                }
              </div>

              <div className="clearfix"></div>
              <div className="block buttons">

                {processing ?
                  <button
                    className="btn btn-danger pull-right"
                    style={{ marginRight: 0, pointerEvents: "none" }}
                  >
                    <Spinner
                      style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                      className="animate-spin -ml-1 mr-3 h-5 w-5 "
                    />
                  </button>
                  : <button
                    className="btn btn-danger pull-right"
                    onClick={() => addPayslip(employee.value)}
                    style={{ marginRight: 0 }}
                  >Create extra Payslip</button>
                }

                <div className="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {

  const employeeOptions = state?.employees?.employeeListWithSalary
    ?.filter(employee => (
      employee.isTerminated 
      && employee.terminationDate < state.payroll.payPeriodDetails.periodStart
      && new Date(employee.terminationDate) > subMonths(new Date(state.payroll.payPeriodDetails.periodStart), 3)
    ))
    ?.map(employee => ({
      value: employee.id,
      label: `${employee.employeeName} ${employee.employeeSurname}`
    }))

  const show = state.payroll.showPayTerminatedEmployeeModal;

  const processing = state.payroll.processingPayTerminatedEmployeeModal;

  return {
    show,
    processing,
    employeeOptions,
  }
}

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(ACTIONS.payTerminatedEmployeeModal(false)),
  addPayslip: (employeeID) => dispatch(ACTIONS.addPayslipForTerminatedEmployee(employeeID)),
  getTerminatedEmployees: () => dispatch(EMPLOYEE_ACTIONS.getTerminatedEmployees()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PayTerminatedEmployeeModal) 
